import * as React from 'react';
import PropTypes from 'prop-types';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Table, TableBody, TableContainer } from '@material-ui/core';
import { Box, CircularProgress, TableCell, TableRow } from '@mui/material';
import { CustomSwitch } from '../../../../components/CustomSwitch';
import { CustomPermissionRow } from './CustomPermissionRow';
import { theme } from '../../../../styled';

export const PermissionsTree = ({ permissions, columns, fetching, fetchingItem, handleSwitcher }) => {
  const tableCellCommonStyle = { padding: '12px 8px 12px 16px !important', lineHeight: '20px' };
  const lastRowCellBorderBottomStyle = (rowIndex, rowsCount) => {
    return rowIndex === rowsCount - 1 ? { borderBottom: 'none' } : {};
  };

  return (
    <TreeView
      aria-label="permissions"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ flexGrow: 1, overflowY: 'auto' }}
      data-testid="PermissionsTreeView"
    >
      {
        Object.keys(permissions).map((sectionSlug, sectionSlugIndex) => (
          <CustomPermissionRow
            key={sectionSlugIndex}
            nodeId={sectionSlugIndex.toString()}
            label={permissions[sectionSlug].sectionName}
            data-testid="CustomPermissionRow"
          >
            <TableContainer>
              <Table position="relative">
                <TableBody>
                  {
                    permissions[sectionSlug].items.map((item, itemIndex) => (
                      <TableRow key={itemIndex} sx={{ backgroundColor: itemIndex % 2 ? theme.palette.divider : theme.palette.grey[600]}}>
                        <TableCell sx={{ ...tableCellCommonStyle, ...lastRowCellBorderBottomStyle(itemIndex, permissions[sectionSlug].items.length) }}>
                          <Box>{item.name || item.slug}</Box>
                        </TableCell>

                        {
                          [...columns].slice(1).map((column) => (
                            <TableCell key={column.id} sx={{ ...tableCellCommonStyle, width: 145, ...lastRowCellBorderBottomStyle(itemIndex, permissions[sectionSlug].items.length) }}>
                              <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                {
                                  fetching && fetchingItem.roleId === column.id && fetchingItem.permissionId === item.id ? (
                                    <Box display="flex" alignItems="center" sx={{ zoom: '.625' }}>
                                      <CircularProgress data-testid="ItemCircularProgress" />
                                    </Box>
                                  ): (
                                    <CustomSwitch
                                      label={''}
                                      checked={item.permissions.indexOf(column.id) > -1}
                                      onChange={
                                        (event) => handleSwitcher(column.id, item.id, event.target.checked)
                                      }
                                      style={{ zoom: .84}}
                                      data-testid="PermissionSwitcher"
                                    />
                                  )
                                }
                              </div>
                            </TableCell>
                          ))
                        }
                      </TableRow>
                    ))
                  }
                  {
                    permissions[sectionSlug].items.length % 2 === 0 && (
                      <TableRow mt="24px">
                        <TableCell colSpan={columns.length} bgcolor={theme.palette.grey[600]} sx={{ borderBottom: 'none' }} />
                      </TableRow>
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </CustomPermissionRow>
        ))
      }
    </TreeView>
  );
};

PermissionsTree.propTypes = {
  permissions: PropTypes.object,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      label: PropTypes.string,
      sx: PropTypes.object,
    })
  ),
  fetching: PropTypes.bool,
  fetchingItem: PropTypes.objectOf(
    PropTypes.shape({
      roleId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      permissionId: PropTypes.string
    })
  ),
  handleSwitcher: PropTypes.func,
};
